module.exports = __webpack_public_path__ + "img/ship.ec0734bb.png";